import { FakePlatformActionsConfig } from "./fakePlatformActions";

const defaultConfig: FakePlatformActionsConfig = {
    authentication: {
        errorMessage: "",
        signinDelay: 1000,
    },
    disconnectionDelay: null,
    ajaxRequestDelay: 100,
    clientError: {
        show: false,
        delay: 3000,
        errorMessage: "Fake client error"
    },
    vsInstancesFetch: {
        errorMessage: ""
    },
    vsInstanceNew: {
        errorMessage: ""
    },
    getScreenshot: {
        errorMessage: ""
    },
    recording: {
        result: "success",
        delayToProcessing: 3000,
        delayToDone: 6000,
        files: [
            "C:\\temp\\ETWLog1.etl",
            "C:\\temp\\ETWLog2.etl"
        ]
    },
    updatedSysLogs: {
        delayForUpdate: 5000,
        filesToUpload: [
            "C:\\Users\\johndoe\\AppData\\Local\\Temp\\LocalInfo_2020-07-10_19-16-04.json",
            "C:\\Program Files (x86)\\Microsoft Visual Studio\\2019\\Preview\\Common7\\IDE\\devenv.isolation.ini",
            "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSInMemoryActivityLog_2020-07-10_19-16-04.xml",
            "C:\\Users\\johndoe\\AppData\\Local\\Temp\\DotNetEventLog_2020-07-10_19-16-04.txt"
        ],
        filesToUploadPerAssembly: [
            {
                assemblyName: "Microsoft.VisualStudio.Shell.Connected",
                filePaths: [
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007070555_MASTER_16.8.30306.11_59192_1f2f0dc7-d503-4fae-9a94-16a587413f5c.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007070555_MASTER_16.8.30306.11_77248_8352626a-1070-418b-be7b-54f5032ac823.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007080913_MASTER_16.8.30306.11_31316_98c407a8-a7c1-4559-9940-84f3a13c59f2.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007091928_MASTER_16.8.30306.11_54492_09303178-460c-4eca-9402-ff055bc3b5cd.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007091929_MASTER_16.8.30306.11_15384_1175fcd9-9713-46b5-a8c9-32a97820fe7c.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007091929_MASTER_16.8.30306.11_42980_c977be9c-4a4a-4a28-a591-396f37fb4be5.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007091929_MASTER_16.8.30306.11_9428_057ef4c7-5692-46f6-bf4c-521a4cb724ab.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007091930_D16.6_16.6.30225.117_50932_2de48ddb-3383-4871-84b4-da155ac445b4.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007100231_MASTER_16.8.30306.11_14364_732a0445-0ee4-4f00-9c79-c3eaa83b1c56.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007100231_MASTER_16.8.30306.11_46924_cf8f9822-7158-4862-8d88-c2386131a495.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\VSFeedbackPerfWatsonData\\202007100710_MASTER_16.8.30309.16_17136_95b5bf1d-1caa-4b24-8b18-dc0dafb89c33.tcdb",
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\ServiceHubLogs_2020-07-10-12-16-04.zip",
                    "C:\\Users\\johndoe\\AppData\\Local\\Microsoft\\VisualStudio\\16.0_2a3aca4a\\componentmodelcache\\Microsoft.VisualStudio.Default.err",
                    "C:\\Users\\johndoe\\AppData\\Local\\Microsoft\\VisualStudio\\16.0_2a3aca4a\\componentmodelcache\\Microsoft.VisualStudio.Default.scan"
                ]
            },
            {
                assemblyName: "Microsoft.VisualStudio.WinForms.Package",
                filePaths: []
            },
            {
                assemblyName: "Microsoft.VisualStudio.LiveShare.FeedbackDiagnostics",
                filePaths: [
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\LiveShareLogs2020-07-10-12-16-04.zip"
                ]
            },
            {
                assemblyName: "Microsoft.VisualStudio.WebClient.Diagnostics.HtmlToolHost",
                filePaths: []
            },
            {
                assemblyName: "NuGet.VisualStudio.Common",
                filePaths: [
                    "C:\\Users\\johndoe\\AppData\\Local\\Temp\\NuGetScratch\\nuget-dg\\nugetSpec.dg"
                ]
            }]
    },
    reserveNewTrackingId: {
        errorMessage: ""
    },
    updateSettings: {
        errorMessage: ""
    },
    selectFiles: {
        errorMessage: ""
    },
    viewFile: {
        errorMessage: ""
    },
    upload: {
        errorMessage: "upload failed"
    }
};

export default defaultConfig;
